import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { chunk } from 'lodash';
import { Fragment } from 'react';
import { SubItemColumn } from '../../../components/Menu/components/SubItemColumn/index.js';
import { SubItemColumnGroup } from '../../../components/Menu/components/SubItemColumnGroup.js';
import { SubItemWrapper } from '../../../components/Menu/components/SubItemWrapper.js';
import { Title } from '../../../components/Menu/components/Title.js';
import { Stack } from '../../../primitives/index.js';
export const SubItems = ({
  items
}) => {
  const isBlock = items.length;
  if (items.every(item => item.items)) {
    return _jsx(SubItemWrapper, {
      direction: "row",
      isBlocks: isBlock > 1,
      divider: isBlock > 1,
      children: items.map(({
        items: subitems,
        itemsPerColumn,
        headline
      }, index) => _jsx(Fragment, {
        children: _jsxs(SubItemColumnGroup, {
          children: [headline && _jsx(Title, {
            children: headline
          }), _jsx(Stack, {
            direction: "row",
            justifyContent: "space-between",
            divider: isBlock <= 1,
            children: chunk(subitems, itemsPerColumn).map((itemsInColumn, columnIndex) => _jsx(SubItemColumn, {
              items: itemsInColumn
            }, columnIndex))
          })]
        })
      }, index))
    });
  }
  return null;
};